import React from 'react';
//import { useTranslation } from "react-i18next";

import {
    Form, Row, Col,
} from "reactstrap";

import * as commonFunc from 'scripts/common';

const AConfigureModel = React.forwardRef(({ onSubmit, noButtons, appProps, checkRights, getRoutes, getUser, modelsList, parentProps, keyMode, configModel, traceModel, loadedData, children, formEditing, prevAction, exceptionConfiguration, forcedDisabled }, ref) => {
    //const { t } = useTranslation();
    /*const { t: trad } = useTranslation();
    var t = (tag, a, b) => {
        tempI[tag] = 1;
        console.debug(tempI);
        return trad(tag, a,b );
    };*/
    //const altT = (label, args) => { return (label && label.startsWith("i18n:")) ? t(label.replace("i18n:", ""), args) : label };

    //Reset des variables globales si changement de location
    /*const location = useLocation();
    React.useEffect(() => {
        dataCache = {};
        //needingCacheCpt = {};
        forcedCreate = false;
        isUpdateGen = false;

        prevQueue = [];
    }, [location]);*/


    var curGenerateTag = "generate-" + Math.floor(Math.random() * 1000000000);

    var curElementList = {};
    const [elementList, setElementList] = React.useState({});
    const [genModel] = React.useState(configModel);
    //const [invalidMerged, setInvalidMerged] = React.useState("1-");
    const [blocksContent, setBlocksContent] = React.useState();
    const [rerender, setRerender] = React.useState(false);

    console.debug("DISPLAY MODEL");
    console.debug(configModel);


    React.useEffect(() => {
        var prefix = "." + curGenerateTag;
        var nodes = document.querySelectorAll(prefix + " [data-bind], " + prefix + " [data-clonable-bind]");

        var blocks = [];
        nodes.forEach((node, index) => {
            var element = { node: node };
            var bindValue = node.getAttribute("data-bind-value") || node.getAttribute("data-bind");

            var camelBindProp;
            if (!commonFunc.isBlank(bindValue)) {
                camelBindProp = commonFunc.camelize(bindValue, true);
                if (!curElementList[camelBindProp]) curElementList[camelBindProp] = element;
                else {
                    camelBindProp = camelBindProp + "2";
                    //bindValue = bindValue + "2";
                    curElementList[camelBindProp] = element;
                }
            }
            else {
                camelBindProp = bindValue;
            }
            element.bindPropResult = bindValue;
            element.camelBindProp = camelBindProp;

            if (loadedData && !commonFunc.isBlank(camelBindProp)) {
                var srcValue = commonFunc.getValue(loadedData, camelBindProp);
                if (element.objType === "picture") {
                    if (typeof srcValue === 'object' && !Array.isArray(srcValue) && srcValue !== null) {
                        element.defaultValue = "";//TODO : Downloadfile valide
                    }
                    else {
                        element.defaultValue = ((srcValue !== null && srcValue !== undefined) ? srcValue : element.defaultValue);
                    }
                }
                else {
                    element.defaultValue = ((srcValue !== null && srcValue !== undefined) ? srcValue : element.defaultValue);
                }
            }

            var target = node;
            if (node.getAttribute("optionshide-parent")) target = node.closest("." + node.getAttribute("optionshide-parent"));
            if (target.classList.contains('d-none')) element.hidden = true;


            blocks.push(element);
        });
        setBlocksContent(blocks);
        setElementList(curElementList);

        return () => {
            //console.debug("unmount");
        }
    }, []);



    React.useImperativeHandle(ref, () => ({
        //submitForm: (isUpdate) => { handleSubmit((data) => { triggerOnSubmit(data, isUpdate) })() },
        //resetForm: () => { reset(); },
        manageModelOptions: (key, optObj, eventObj, newTarget) => {
            console.debug("manageModelOptions");
            var dataList = Object.keys(elementList).length > 0 ? elementList : curElementList;
            var targetComp = newTarget;
            switch (key) {
                case "SIGNEMP":
                    if (!targetComp) targetComp = dataList[commonFunc.camelize(optObj.altValue || "extras.signEmp", true)];
                    if (targetComp) {
                        targetComp.hidden = !eventObj.target.checked;
                        targetComp.functionManager?.rerender();
                        genModel.cEdited = true;
                    }
                    /*else {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: "Echec de la modification<br/>Composant introuvable"
                        });
                        eventObj.target.checked = false;
                    }*/
                    break;
                case "SIGNCLI":
                    if (!targetComp) targetComp = dataList[commonFunc.camelize(optObj.altValue || "extras.signCli", true)];
                    if (targetComp) {
                        targetComp.hidden = !eventObj.target.checked;
                        targetComp.functionManager?.rerender();
                        genModel.cEdited = true;
                    }
                    /*else {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: "Echec de la modification<br/>Composant introuvable"
                        });
                        eventObj.target.checked = false;
                    }*/
                    break;
                case "TGSTARTEND":
                    if (!targetComp) targetComp = dataList[commonFunc.camelize(optObj.altValue || "extras.sessionStartDate", true)];
                    if (targetComp) {
                        targetComp.hidden = !eventObj.target.checked;
                        targetComp.functionManager?.rerender();
                        genModel.cEdited = true;
                    }
                    targetComp = dataList[commonFunc.camelize(optObj.altValue || "extras.sessionEndDate", true)];
                    if (targetComp) {
                        targetComp.hidden = !eventObj.target.checked;
                        targetComp.functionManager?.rerender();
                        genModel.cEdited = true;
                    }
                    break;
                case "PHOTOS2":
                    Object.keys(dataList).forEach((dlKey) => {
                        if (dlKey.startsWith("photoTech2")) {
                            targetComp = dataList[dlKey];
                            if (targetComp) {
                                targetComp.hidden = !eventObj.target.checked;
                                targetComp.functionManager?.rerender();
                                genModel.cEdited = true;
                            }
                        }
                    });
                    break;
                case "TECHPICCLONE":
                    Object.keys(dataList).forEach((dlKey) => {
                        if (dlKey.startsWith("photosBtnGroup")) {
                            targetComp = dataList[dlKey];
                            if (targetComp) {
                                targetComp.hidden = !eventObj.target.checked;
                                targetComp.functionManager?.rerender();
                                genModel.cEdited = true;
                            }
                        }
                    });
                    break;
                case "PDFPRECO":
                    if (!targetComp) targetComp = dataList[commonFunc.camelize(optObj.altValue || "extras.conclusion", true)];
                    if (targetComp) {
                        targetComp.hidden = !eventObj.target.checked;
                        targetComp.functionManager?.rerender();
                        genModel.cEdited = true;
                    }
                    targetComp = dataList[commonFunc.camelize(optObj.altValue || "extras.preconisation", true)];
                    if (targetComp) {
                        targetComp.hidden = !eventObj.target.checked;
                        targetComp.functionManager?.rerender();
                        genModel.cEdited = true;
                    }
                    targetComp = dataList[commonFunc.camelize(optObj.altValue || "extras.conclusion2", true)];
                    if (targetComp) {
                        targetComp.hidden = eventObj.target.checked;
                        targetComp.functionManager?.rerender();
                        genModel.cEdited = true;
                    }
                    targetComp = dataList[commonFunc.camelize(optObj.altValue || "extras.preconisation2", true)];
                    if (targetComp) {
                        targetComp.hidden = eventObj.target.checked;
                        targetComp.functionManager?.rerender();
                        genModel.cEdited = true;
                    }
                    break;
                default: break;
            }
            setRerender(!rerender);//TEMP
        }
    }));


    function manageBlocks() {
        blocksContent.forEach((element) => { 
            element.functionManager = {};
            element.functionManager.rerender = () => {
                var prefix = "." + curGenerateTag;
                var node = document.querySelector(prefix + " .content-container [data-bind='" + element.bindPropResult + "'], " + prefix + " .content-container [data-bind-value='" + element.bindPropResult + "']");
                var target = node;
                if (node.getAttribute("optionshide-parent")) target = node.closest("." + node.getAttribute("optionshide-parent"));
                if (element.hidden) {
                    target.classList.add('d-none');
                    target.classList.add('displayNone');
                }
                else {
                    target.classList.remove('d-none');
                    target.classList.remove('displayNone');
                }

                var content = document.querySelector(prefix + " .content-container");
                genModel.Details = content.innerHTML;
            };
        });
    }
    if (blocksContent) manageBlocks();


    function renderData(cfg) {
        curElementList = {};

        //var content = cfg ? componentTyped(cfg) : "";
        var content = <div className="content-container" dangerouslySetInnerHTML={{ __html: cfg?.Details }}></div>

        return <Form action="" className={`form needs-validation h-100 ${curGenerateTag}`} method="">
            <div className={`w-100`}>
                {blocksContent?.length ? <div className="bg-secondary">{blocksContent.map((block, index) => <div key={index + block.bindPropResult} className={`badge ${block.hidden ? "badge-danger" : ""}`}>TEST {block.bindPropResult}</div>)}</div> : ""}
                {content}
                {children}
            </div>
        </Form>;
    }

    const content = renderData(genModel);




    return <><Row className="editor-model h-100">
        <Col className="h-100" xs={exceptionConfiguration ? "12" : "9"}>{content}</Col>
    </Row>
    </>;

});

export default AConfigureModel;